import { Link } from 'react-router-dom';

export function ListingLocationPin(props: { subArea: string; area: string }) {
  if (!props.subArea && !props.area) return <></>;

  const isSubArea = !!props.subArea;
  const linkUrl = isSubArea
    ? `/properties?area=${props.area}&subArea=${props.subArea}`
    : `/properties?area=${props.area}`;
  const caption = isSubArea ? props.subArea : props.area;

  return (
    <Link to={linkUrl}>
      <i className='flaticon-pin'></i> {caption}
    </Link>
  );
}
